import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconService } from './icon.service';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    MatIconModule,
    HttpClientModule,
    CommonModule
  ],
  providers: [
    IconService
  ],
  exports: [
    MatIconModule
  ]
})
export class IconsModule {

    constructor(private iconService: IconService) {
      if (!this.iconService.initialized) {
        // register existing icons
        // TODO: someday, each module/app using this should add icon sets themselves
        this.iconService.init();
      }
    }
}
